import { AssetType } from '@amzn/fire-tv-campaign-automation-service';
import shell12InchPortrait from 'public/images/tablet-shells/FireTabletsFeatureRotator_12Inch_Portrait_KH_Shell.png';
import {
  PreviewStateConfig,
  LayerType,
  BackgroundTransformType,
  LogoTransformType,
  GradientDirection,
} from 'src/utils/preview/types';

import {
  ALT_TEXT,
  SHIFT_FACTOR,
  GRADIENT_DARK,
  GRADIENT_TRANSPARENT,
  SCRIM_START,
  SCRIM_END,
  FONT_FAMILY,
  TEXT_COLOR,
  MAX_LINES,
} from '../constants';

export const TABLET_12INCH_PORTRAIT_KH: PreviewStateConfig = {
  label: '12" Portrait KH',
  altText: ALT_TEXT,
  dimensions: { width: 920, height: 1400 },
  layers: [
    {
      type: LayerType.BACKGROUND,
      transform: {
        type: BackgroundTransformType.CENTER_CROP,
        shiftFactor: SHIFT_FACTOR,
        x: 60,
        y: 216,
        width: 800,
        height: 400,
      },
    },
    {
      type: LayerType.GRADIENT,
      direction: GradientDirection.HORIZONTAL,
      colorStops: [
        { position: 0, color: GRADIENT_DARK },
        { position: 1, color: GRADIENT_TRANSPARENT },
      ],
      bounds: { x: 60, y: 216, width: 510, height: 400 },
    },
    {
      type: LayerType.LOGO,
      transform: {
        type: LogoTransformType.FIT_WITHIN,
        maxWidth: 297,
        maxHeight: 120,
        position: { x: 100, y: 261 },
      },
    },
    {
      type: LayerType.TEXT,
      position: {
        x: 100,
        y: 391,
      },
      fontSize: 23,
      fontFamily: FONT_FAMILY,
      color: TEXT_COLOR,
      maxWidth: 300,
      maxLines: MAX_LINES,
      lineHeight: 30,
    },
    {
      type: LayerType.GRADIENT,
      direction: GradientDirection.VERTICAL,
      colorStops: [
        { position: 0, color: SCRIM_START },
        { position: 1, color: SCRIM_END },
      ],
      bounds: { x: 60, y: 216, width: 800, height: 35 },
    },
    {
      type: LayerType.GRADIENT,
      direction: GradientDirection.VERTICAL,
      colorStops: [
        { position: 0, color: SCRIM_END },
        { position: 1, color: SCRIM_START },
      ],
      bounds: { x: 60, y: 546, width: 800, height: 70 },
    },
    { type: LayerType.SHELL, src: shell12InchPortrait },
  ],
  assetRequirements: [AssetType.BACKGROUND_IMAGE, AssetType.LOGO],
};
